import { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Logo from "../../composant/image.png";
import "./SuiviClient.css";

const API = "https://suivi.amservices.eu/api";
const ETAPES = [
    ["pris_en_charge", "Pris en charge"],
    ["diagnostic", "Diagnostic"],
    ["pieces_commandees", "Pièces commandées"],
    ["pieces_recues", "Pièces reçues"],
    ["termine", "Prêt à récupérer"],
    ["recupere", "Récupéré"]
];

export default function SuiviClient() {
    const { token } = useParams();
    const [suivi, setSuivi] = useState(null);
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(true);

    const loadTracking = useCallback(async () => {
        try {
            const response = await fetch(`${API}/get_tracking.php?token=${encodeURIComponent(token)}`, {
                cache: "no-store"
            });
            const data = await response.json();
            if (!response.ok || !data.success) throw new Error(data.message || "Suivi indisponible");
            setSuivi(data.data);
            setError("");
        } catch (err) {
            setError(err.message || "Impossible de charger le suivi");
        } finally {
            setLoading(false);
        }
    }, [token]);

    useEffect(() => {
        loadTracking();
        const refresh = window.setInterval(loadTracking, 20000);
        return () => window.clearInterval(refresh);
    }, [loadTracking]);

    const currentIndex = suivi ? ETAPES.findIndex(([value]) => value === suivi.etat) : -1;

    return (
        <div className="tracking-page">
            <section className="tracking-card">
                <div className="tracking-logo-wrap">
                    <img className="tracking-logo" src={Logo} alt="AM Services" />
                </div>
                <h1>Suivi de votre réparation</h1>
                <p className="tracking-intro">Consultez ici l’avancement de votre matériel en temps réel.</p>
                {loading && <p className="tracking-loading">Chargement du suivi...</p>}
                {error && <p className="tracking-error" role="alert">{error}</p>}
                {suivi && (
                    <>
                        <div className="tracking-summary">
                            <div className="tracking-summary-item">
                                <span>Dossier</span>
                                <strong>{suivi.reference}</strong>
                            </div>
                            <div className="tracking-summary-item">
                                <span>Matériel</span>
                                <strong>{suivi.appareils.join(", ") || "Non renseigné"}</strong>
                            </div>
                        </div>
                        <ol className="tracking-steps">
                            {ETAPES.map(([value, label], index) => (
                                <li key={value} className={index <= currentIndex ? "done" : ""}>
                                    <span className="tracking-dot">{index < currentIndex ? "✓" : index + 1}</span>
                                    <span>{label}</span>
                                </li>
                            ))}
                        </ol>
                        <p className="tracking-refresh"><span aria-hidden="true">●</span> Mise à jour automatique toutes les 20 secondes</p>
                    </>
                )}
            </section>
        </div>
    );
}
